"use client";
import icons from "@/assets/icons";
import { useEffect, useState } from "react";
import Modal from "./modal/Modal";

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [showInstallButton, setShowInstallButton] = useState<boolean>(false);
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const [isIosDevice, setIsIosDevice] = useState(false);
  const [isWindowsDevice, setIsWindowsDevice] = useState(false);
  const [showIosDesc, setShowIosDesc] = useState(false);

  useEffect(() => {
    isPWAInstalled();
    setIsIosDevice(isIos());
    setIsWindowsDevice(isWindows());
  }, []);

  const isPWAInstalled = async () => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsAppInstalled(true);
      return;
    }
    if ("getInstalledRelatedApps" in window.navigator) {
      const relatedApps = await (navigator as any).getInstalledRelatedApps();
      let installed = false;
      if (relatedApps.length > 0) {
        relatedApps.forEach((app: any) => {
          if (app.url === "https://sandcatapp.ir/manifest.json") {
            installed = true;
          }
        });
      }
      setIsAppInstalled(installed);
    }
  };

  const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };

  const isWindows = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /windows/.test(userAgent);
  };

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (e: Event) => {
  //     e.preventDefault();
  //     setDeferredPrompt(e);
  //     setShowInstallButton(true);
  //   };

  //   window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

  //   return () => {
  //     window.removeEventListener(
  //       "beforeinstallprompt",
  //       handleBeforeInstallPrompt,
  //     );
  //   };
  // }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      setShowInstallButton(false);
      (deferredPrompt as any).prompt();
      (deferredPrompt as any).userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        setDeferredPrompt(null);
      });
      setIsAppInstalled(true);
    }
  };

  const togglePrompt = () => {
    setIsAppInstalled(true);
  };

  const toggleIosModal = () => {
    setShowIosDesc(!showIosDesc);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/SandCatApp-1.0.2.apk"; // Replace with the actual URL to your APK file
    link.download = "SandCatApp.apk"; // Name for the downloaded file
    link.click();
    setIsAppInstalled(true);
  };

  return (
    <>
      {!isAppInstalled && !isIosDevice && !isWindowsDevice && (
        <div className="flex w-full h-16 z-50 rounded-xl bg-bg-cards flex-row justify-between items-center p-4">
          <button onClick={() => togglePrompt()} className="w-4 h-4">
            {icons.close}
          </button>
          <img src="/icons/icon-192x192.png" alt="" className="w-12 h-12" />
          سندکت را نصب کنید
          <button
            onClick={() => handleDownload()}
            className="flex rounded-xl border border-tertiary p-1"
          >
            نصب
          </button>
        </div>
      )}

      {!isAppInstalled && isIosDevice && (
        <div className="flex w-full h-16 z-50 rounded-xl bg-bg-cards flex-row justify-between items-center p-4">
          <button onClick={() => togglePrompt()} className="w-4 h-4">
            {icons.close}
          </button>
          <img src="/icons/icon-192x192.png" alt="" className="w-12 h-12" />
          سندکت را نصب کنید
          <button
            onClick={() => toggleIosModal()}
            className="flex rounded-xl border border-tertiary p-1"
          >
            نصب
          </button>
          {showIosDesc && (
            <div className="justify-center items-center w-[1128px] min-h-[600px]">
              <Modal
                handleModal={toggleIosModal}
                title=" "
                styleClass=" min-h-[600px]"
              >
                <div>
                  <p>
                    برای اضافه کردن سندکت به صفحه اصلی خود به این صورت عمل کنید:
                  </p>
                  <p>
                    از نوار پایین صفحه خود، دکمه اشتراک گذاری را انتخاب کنید
                  </p>
                  <p>سپس روی افزودن به صفحه اصلی کلیک کنید</p>
                </div>
              </Modal>
            </div>
          )}
        </div>
      )}

      {!isAppInstalled && isWindowsDevice && (
        <div className="flex w-full h-16 z-50 rounded-xl bg-bg-cards flex-row justify-between items-center p-4">
          <button onClick={() => togglePrompt()} className="w-4 h-4">
            {icons.close}
          </button>
          <img src="/icons/icon-192x192.png" alt="" className="w-12 h-12" />
          سندکت را نصب کنید
          <button
            onClick={() => handleInstallClick()}
            className="flex rounded-xl border border-tertiary p-1"
          >
            نصب
          </button>
        </div>
      )}
    </>
  );
};

export default InstallPrompt;
